// import i18n from '../i18n'
export default {
  install: function (Vue) {
    const HASH_LENGTH = 16
    const SEED_CHAR = 'abcdefghijklmnopqrstuvwxyz'
    Vue.prototype.$util = {
      formatDate (date, withTime) {
        return withTime
          ? `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
              "0" + date.getDate()
            ).slice(-2)} ${date.getHours()}:${date.getMinutes()}`
          : `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
              "0" + date.getDate()
            ).slice(-2)}`;
      },
      formatJpDate (date, withTime) {
        return withTime
          ? `${date.getFullYear()}年${(date.getMonth() + 1)}月${(date.getDate())}日 ${date.getHours()}時${date.getMinutes()}分`
          : `${date.getFullYear()}年${(date.getMonth() + 1)}月${(date.getDate())}日`;
      },
      formatJpMonthDay (date, withTime) {
        return withTime
          ? `${(date.getMonth() + 1)}月${(date.getDate())}日 ${date.getHours()}時${date.getMinutes()}分`
          : `${(date.getMonth() + 1)}月${(date.getDate())}日`;
      },
      formatJpTime (date) {
        return `${date.getHours()}時${date.getMinutes()}分`
      },
      generateHash () {
        let hash = ''
        for (let hashCharIdx = 0; hashCharIdx < HASH_LENGTH; hashCharIdx++) {
          hash += SEED_CHAR[Math.floor(Math.random() * Math.floor(SEED_CHAR.length))]
        }
        return hash
      },
      extractTime (dateString) {
        return dateString.split(' ')[1]
      }
    }
  }
}